import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/kellymears/code/projects/cli/bud/bud-sandbox/web/app/themes/wp-react-hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Alert } from 'docz';
import { Link } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "wp-react-hooks"
    }}>{`WP React Hooks`}</h1>
    <p>{`A hooks library for the WordPress block editor.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`This project is pre-release`}</strong>{`. It will eventually be available at `}<inlineCode parentName="p">{`tinypixelco/wp-react-hooks`}</inlineCode>{`. For now you will need to clone the repo to your project directly.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`This documentation is in development.`}</p>
    </blockquote>
    <h2 {...{
      "id": "block-hooks"
    }}>{`Block hooks`}</h2>
    <p>{`Hooks related to block objects and block-specific functionality.`}</p>
    <ul>
      <li parentName="ul"><Link to="/use-blocks" mdxType="Link">useBlocks</Link></li>
      <li parentName="ul"><Link to="/use-selection" mdxType="Link">useSelection</Link></li>
    </ul>
    <h2 {...{
      "id": "post-hooks"
    }}>{`Post hooks`}</h2>
    <p>{`Hooks related to WordPress post data.`}</p>
    <ul>
      <li parentName="ul"><Link to="/use-post-template" mdxType="Link">usePostTemplate</Link></li>
      <li parentName="ul"><Link to="/use-post-title" mdxType="Link">usePostTitle</Link></li>
      <li parentName="ul"><Link to="/use-post-type" mdxType="Link">usePostType</Link></li>
    </ul>
    <h2 {...{
      "id": "editor-hooks"
    }}>{`Editor hooks`}</h2>
    <p>{`Hooks related to the editor and its settings.`}</p>
    <ul>
      <li parentName="ul"><Link to="/use-colors" mdxType="Link">useColors</Link></li>
      <li parentName="ul"><Link to="/use-font-sizes" mdxType="Link">useFontSizes</Link></li>
      <li parentName="ul"><Link to="/use-settings" mdxType="Link">useSettings</Link></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      